import { render, staticRenderFns } from "./PositionRecommendationModal.vue?vue&type=template&id=63ef0482&scoped=true"
import script from "./PositionRecommendationModal.vue?vue&type=script&lang=js"
export * from "./PositionRecommendationModal.vue?vue&type=script&lang=js"
import style0 from "./PositionRecommendationModal.vue?vue&type=style&index=0&id=63ef0482&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef0482",
  null
  
)

export default component.exports